import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import {IntegrationsStatus, IntegrationsType} from 'common/constants/success';
import {Integration, IntegrationsByType} from 'common/models/success';
import {groupBy} from 'lodash';
import {setErrorAction} from 'ui/store/system/actions/setError';
import getRequestError from 'ui/store/utils/getRequestError';
import withAbortRequest from 'ui/store/utils/withAbortRequest';
import {sdk} from 'ui/utils/sdk';

import {namespace} from '../constants';
import {AsyncThunkConfig, ReducerCallback} from '../success.types';

interface PrepareIntegrations {
    answerKey: string | null;
}

const prepareIntegrationsAction = createAction<IntegrationsByType>(
    `${namespace}/prepareIntegrations`,
);

export const reducerPrepareIntegrations: ReducerCallback<IntegrationsByType> = (
    state,
    {payload},
) => {
    state.integrations = payload;
};

const prepareIntegrations = createAsyncThunk<void, PrepareIntegrations, AsyncThunkConfig<void>>(
    'prepareIntegrations',
    ({answerKey}, {signal, dispatch}) =>
        withAbortRequest(
            sdk.form.getIntegrations({answerKey}).then((integrations: Integration[]) => {
                const groupedIntegrations = groupBy(integrations, 'type');
                const mappedIntegrations = {} as IntegrationsByType;

                (Object.keys(groupedIntegrations) as IntegrationsType[]).forEach((key) => {
                    mappedIntegrations[key] = {
                        // TODO: handle canceled status?
                        failed: groupedIntegrations[key].filter(
                            ({status}) => status === IntegrationsStatus.Error,
                        ),
                        succeed: groupedIntegrations[key].filter(
                            ({status}) => status === IntegrationsStatus.Success,
                        ),
                        isSomePending: groupedIntegrations[key].some(
                            ({status}) => status === IntegrationsStatus.Pending,
                        ),
                    };
                });
                dispatch(prepareIntegrationsAction(mappedIntegrations));
            }),
            signal,
        )
            .catch(getRequestError)
            .catch((status) => {
                dispatch(setErrorAction(status));
                return status;
            }),
);

export default prepareIntegrations;
